
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-orders",
  components: {},
})
export default class IconOrders extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;

  constructor() {
    super();
  }
}
